<template>
  <section class="disclaimer has-text-left">
    <b-message type="is-warning">
      <strong>Disclaimer</strong>:
      This website is simply for educational purposes and is
      <strong>NOT</strong> an official UCSD website.
      <em>Don't see your department?</em>
      For the complete list of departments and courses,
      please visit the "UCSD General Catalog for 2020-21"
      <a href="http://ucsd.edu/catalog/front/courses.html" target="_blank" rel="noopener noreferrer">here</a>.
      <em>Note:</em> Current production recommends using desktop version.
    </b-message>
  </section>
</template>

<script>
export default {
  name: 'Disclaimer',
};
</script>

<style lang="scss">
</style>
